export default class Button {
    constructor(element) {
        this.element = element;
        this.prepareDOM();
    }

    prepareDOM() {
        if(!this.element.classList.contains("button--icon")) {
            return;
        }

        let imageElement = this.element.querySelector("img");

        if(!imageElement) {
            return;
        }

        let source = imageElement.src;

        fetch(source)
            .then(res => {
                return res.text();
            })
            .then((data) => {
            let container = document.createElement("div");
            container.innerHTML = data;

            console.log(container)

            let svg = container.querySelector("svg");

            imageElement.parentNode.replaceChild(svg, imageElement);
        })
    }
}